<script lang="ts">
	interface Props {
		id?: string
		testid?: string
		value?: string
		error?: string
		label?: string
		placeholder?: string
		disabled?: boolean
		rows?: number // Default number of rows in the textarea
		externalStyle?: string
		input?: (value: string) => void
	}

	let {
		id = 'comment-text-area',
		testid,
		value = $bindable(''),
		error = '',
		label = '',
		placeholder = '',
		disabled = false,
		rows = 3,
		externalStyle = '',
		input
	}: Props = $props()

	function handleInput(event: Event) {
		const target = event.target as HTMLTextAreaElement
		value = target.value
		input?.(value)
	}
</script>

<label class="block">
	{#if label}
		<span class="block">{label}</span>
	{/if}
	<textarea
		{id}
		data-testid={testid}
		class="textarea"
		style={externalStyle}
		class:error
		{placeholder}
		bind:value
		oninput={handleInput}
		{disabled}
		{rows}
	></textarea>
	{#if error}
		<span class="block error-text">{error}</span>
	{/if}
</label>

<style>
	.textarea {
		border-radius: 8px;
		padding: 8px 12px;
		margin: 0;
		width: 100%; /* To fit container width */
		resize: vertical; /* Allows vertical resizing */
		background: #1e1e1e;
		color: #ffaa33;
		outline: none;
		border: none;
		margin-top: 4px;
	}

	.block {
		display: block;
		color: #606266;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
	}

	.error {
		border-color: #f55;
	}

	.error-text {
		color: #f55;
	}
</style>
